import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import Col from "react-bootstrap/Col";
import { Autoplay, Pagination } from "swiper";

import "./horoscopepage.css";
import corporate from "../img/corporate-training.png";
import banner from "../img/inner-desktop-banners/blessing-inner-horscope-banner.webp";
import bannerMobile from "../img/inner-mobile-banners/Horoscope-blessing-mobile.webp";

import GetApiCall from "../API/GETAPI";
import { Row, Skeleton } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Appointmentform from "../appointmentpage/appointmentform";
import { Container, Modal } from "react-bootstrap";
import PostApiCall from "../API/POSTAPI";
import createDOMPurify from "dompurify";
import GetSeoData from "../API/GetSeoData";
import moment from "moment";
const DOMPurify = createDOMPurify(window);

export default function Horoscopepage() {
  const [horoscopeData, setHoroscopeData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [serviceTitle, setServiceTitle] = useState("");
  useEffect(() => {
    GetHoroscopeData();
    GetServiceData();
  }, []);

  const GetServiceData = () => {
    PostApiCall.postRequest(
      {
        catCount: "*",
        whereClause: "",
      },
      "Services"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setServiceData(
            obj1.data.filter((data) => data.fld_status === "Active")
          );
          console.log(obj1.data);
        }
      })
    );
  };

  const GetHoroscopeData = () => {
    PostApiCall.postRequest(
      {
        catCount: "*",
        whereClause: "",
      },
      "GetHoroscope"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setHoroscopeData(
            obj1.data.filter((data) => data.fld_status === "Active")
          );
          console.log(obj1.data.filter((data) => data.fld_status === "Active"));
        }
      })
    );
  };
  // for modal
  const [showForm, setShowForm] = useState(false);

  const showModal = (items) => {
    setServiceTitle(items.fld_service_name);
    setShowForm(true);
  };

  const closeModal = () => {
    setShowForm(false);
  };
  return (
    <>
      <GetSeoData type="horoscope prediction" id={null} />

      <section className="inner-section horoscope-page">
        {/* <NavBar /> */}
        {/* <div className="page-title-area">
          <div className="container-fluid pe-4 h-100 d-flex justify-content-end align-items-center">
            <div className="page-title-content">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Horoscope Prediction</li>
              </ul>
            </div>
          </div>
        </div> */}
        <div className="position-relative">
          <img
            alt="About Banner"
            src={window.innerWidth > 568 ? banner : bannerMobile}
            className="img-fluid w-100 "
          />
          <h2 className="text-start m-0">
            Best Astrology prediction
            <br className="d-lg-none d-block" /> in India
          </h2>
        </div>
        <section className="horoscope-section pt-4 py-lg-4 spacing">
          <div className="container-fluid">
            <div className="row">
              <div className="main-heading text-center mb-0 col-12">
                {/* <h1>Weekly Horoscope Prediction</h1> */}
                {/* <h5>27th Jan - 2nd Feb</h5> */}
                <h5>
                  {moment(horoscopeData[0]?.fld_fromdate).format("Do MMM")} -{" "}
                  {moment(horoscopeData[0]?.fld_todate).format("Do MMM")}{" "}
                </h5>
                <p>Check your Moon and Ascendant Signs</p>
              </div>
              {horoscopeData?.length > 0 ? (
                horoscopeData?.map((data, index) => (
                  <div className="col-md-6 py-md-2 px-md-3 mb-3" key={index}>
                    <div className="service-card horoscope-card-image horoscope-page-card">
                      <div>
                        <div className="icon-wrapper mb-3">
                          <img src={data.fld_image} alt={data.fld_name}></img>
                        </div>
                        <h3>{data.fld_name}</h3>
                        {/* <p className=" ">
                          {data.fld_long_desc.replace(/<\/?p>/g, "")}
                        </p> */}
                        <p
                          className="service-ellipse"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(data.fld_long_desc),
                          }}
                        />
                        <div className="text-start w-100 mb-4 lucky">
                          <div className="me-3 d-flex">
                            <strong>Lucky Color :</strong>
                            <div
                              className="color-box mx-1 d-flex align-items-center"
                              style={{
                                background: `${data.fld_colorcode}`,
                              }}></div>{" "}
                            {data.fld_color}
                          </div>
                          <span className="">
                            <strong>Lucky Number :</strong>{" "}
                            {data.fld_lucky_number}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-left justify-content-left read-more">
                        <a onClick={() => showModal(data)}>
                          Book An Appointment
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <>
                  <div className="col-md-6 py-md-2 px-md-3 mb-3">
                    <div className="service-card horoscope-card-image horoscope-page-card">
                      <div>
                        <div className="icon-wrapper mb-3">
                          <Skeleton.Image></Skeleton.Image>
                        </div>
                        <h3>
                          <Skeleton.Input />
                        </h3>
                        <p className=" ">
                          <Skeleton.Input />
                        </p>
                        <div className="text-start w-100 mb-4 lucky">
                          <div className="me-3 d-flex">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </div>
                          <span className="">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-left justify-content-left read-more">
                        <a href="/contact-us">
                          <Skeleton.Button />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 py-md-2 px-md-3 mb-3">
                    <div className="service-card horoscope-card-image horoscope-page-card">
                      <div>
                        <div className="icon-wrapper mb-3">
                          <Skeleton.Image></Skeleton.Image>
                        </div>
                        <h3>
                          <Skeleton.Input />
                        </h3>
                        <p className=" ">
                          <Skeleton.Input />
                        </p>
                        <div className="text-start w-100 mb-4 lucky">
                          <div className="me-3 d-flex">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </div>
                          <span className="">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-left justify-content-left read-more">
                        <a href="/contact-us">
                          <Skeleton.Button />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 py-md-2 px-md-3 mb-3">
                    <div className="service-card horoscope-card-image horoscope-page-card">
                      <div>
                        <div className="icon-wrapper mb-3">
                          <Skeleton.Image></Skeleton.Image>
                        </div>
                        <h3>
                          <Skeleton.Input />
                        </h3>
                        <p className=" ">
                          <Skeleton.Input />
                        </p>
                        <div className="text-start w-100 mb-4 lucky">
                          <div className="me-3 d-flex">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </div>
                          <span className="">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-left justify-content-left read-more">
                        <a href="/contact-us">
                          <Skeleton.Button />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 py-md-2 px-md-3 mb-3">
                    <div className="service-card horoscope-card-image horoscope-page-card">
                      <div>
                        <div className="icon-wrapper mb-3">
                          <Skeleton.Image></Skeleton.Image>
                        </div>
                        <h3>
                          <Skeleton.Input />
                        </h3>
                        <p className=" ">
                          <Skeleton.Input />
                        </p>
                        <div className="text-start w-100 mb-4 lucky">
                          <div className="me-3 d-flex">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </div>
                          <span className="">
                            <strong>
                              <Skeleton.Button />
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-left justify-content-left read-more">
                        <a href="/contact-us">
                          <Skeleton.Button />
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <Col xs={12} className="main-heading mb-0 mt-3 text-center">
                {/* <h4><span>What Do Our Clients Say</span> About Us?</h4> */}
                <h3>Our Services</h3>
                <p>Nurture Your Spiritual Journey with Our Offerings</p>
              </Col>

              <div className="col-12">
                <Swiper
                  spaceBetween={30}
                  loop={true}
                  pagination={{
                    clickable: true,
                  }}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 40,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  }}
                  autoplay={{
                    delay: 5000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                  }}
                  modules={[Autoplay, Pagination]}
                  className="mySwiper testimonial-swiper services-swiper pt-2">
                  {serviceData.length > 0 ? (
                    serviceData.map((items, index) => (
                      <SwiperSlide key={index}>
                        <div className="">
                          <div className="service-card text-center justify-content-center">
                            <div className="icon-wrapper mx-auto">
                              <img
                                src={items.fld_icon}
                                className="img-fluid"
                                alt={`${items.fld_service_name} Blessings Astrology | Dr. Surabhi Bhatnagar`}></img>
                            </div>
                            <h3>{items.fld_service_name}</h3>
                            <p
                              className="service-ellipse text-center"
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  items.fld_short_desc
                                ),
                              }}
                            />
                            {/* <p>{items.fld_short_desc.replace(/<\/?p>/g, "")}</p> */}
                            <div className="d-flex gap-3 justify-content-center">
                              <div className="read-more">
                                <Link to={`/service/${items?.fld_route}`}>
                                  {" "}
                                  Read More
                                </Link>
                              </div>
                              <div className="book-now">
                                <a onClick={() => showModal(items)}>Book Now</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))
                  ) : (
                    <>
                      <SwiperSlide>
                        <div className="">
                          <div className="service-card">
                            <div className="icon-wrapper">
                              <Skeleton.Image></Skeleton.Image>
                            </div>
                            <h3>
                              <Skeleton.Input />
                            </h3>
                            <p>
                              <Skeleton.Input />
                            </p>
                            <div className="d-flex gap-3">
                              <div className="read-more">
                                <Skeleton.Button />
                              </div>
                              <div className="book-now">
                                <a href="/contact-us">
                                  <Skeleton.Button />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="">
                          <div className="service-card">
                            <div className="icon-wrapper">
                              <Skeleton.Image></Skeleton.Image>
                            </div>
                            <h3>
                              <Skeleton.Input />
                            </h3>
                            <p>
                              <Skeleton.Input />
                            </p>
                            <div className="d-flex gap-3">
                              <div className="read-more">
                                <Skeleton.Button />
                              </div>
                              <div className="book-now">
                                <a href="/contact-us">
                                  <Skeleton.Button />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="">
                          <div className="service-card">
                            <div className="icon-wrapper">
                              <Skeleton.Image></Skeleton.Image>
                            </div>
                            <h3>
                              <Skeleton.Input />
                            </h3>
                            <p>
                              <Skeleton.Input />
                            </p>
                            <div className="d-flex gap-3">
                              <div className="read-more">
                                <Skeleton.Button />
                              </div>
                              <div className="book-now">
                                <a href="/contact-us">
                                  <Skeleton.Button />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="">
                          <div className="service-card">
                            <div className="icon-wrapper">
                              <Skeleton.Image></Skeleton.Image>
                            </div>
                            <h3>
                              <Skeleton.Input />
                            </h3>
                            <p>
                              <Skeleton.Input />
                            </p>
                            <div className="d-flex gap-3">
                              <div className="read-more">
                                <Skeleton.Button />
                              </div>
                              <div className="book-now">
                                <a href="/contact-us">
                                  <Skeleton.Button />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>

                      <SwiperSlide>
                        <div className="">
                          <div className="service-card shop-online">
                            <div className="icon-wrapper">
                              <img src={corporate} alt="Corporate Training" />
                            </div>

                            <h3>Corporate Training</h3>
                            <p>
                              Blessings Astrology offers unique and
                              comprehensive corporate training sessions designed
                              to enhance employee well-being...
                            </p>
                            <div className="d-flex gap-3">
                              <div className="read-more ">
                                <a href="/corporate-training-service">
                                  {" "}
                                  Read More
                                </a>
                              </div>
                              <div className="book-now ">
                                <a
                                  onClick={() =>
                                    showModal("Corporate Training")
                                  }>
                                  Book Now
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </>
                  )}
                </Swiper>
              </div>
            </div>
          </div>
        </section>
        <div className="pb-4 spacing">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <h3>
                  Weekly Horoscope from India's Top Astrology Specialists: Dr.
                  Surabhi Bhatnagar
                </h3>
                <p>
                  You can find reliable horoscope predictions in India at
                  Blessings Astrology. Welcome to their horoscope area. Whether
                  you're trying to make sense of your day, prepare for the
                  coming week, or need help making big life decisions, our
                  carefully chosen horoscopes provide insights based on
                  astrological knowledge and old Vedic wisdom. Our best
                  Astrology predictions in India are based on a thorough grasp
                  of planetary movements and how they affect your individual
                  chart. Horoscopes, in our opinion at Blessings Astrology, are
                  cosmic roadmaps that assist you in coordinating your ideas,
                  feelings, and behaviors with the cosmos rather than only
                  providing broad predictions. Our astrologers research your
                  planetary changes, sun sign, and moon sign to provide you with
                  precise and perceptive forecasts that will enable you to face
                  everyday life with assurance.
                </p>
                <h3>
                  Daily and Weekly Horoscope Updates from Skilled Astrologer
                </h3>
                <p>
                  Our Astrology Weekly Horoscope is specifically designed to
                  help you be ready for the coming days. Our team of skilled
                  astrologers deciphers astrological patterns every week to
                  identify significant possibilities and difficulties for every
                  sign of the zodiac. These forecasts are based on
                  tried-and-true astrological calculations and are tailored for
                  practical uses in fields like relationships, career, money,
                  health, and personal development. They are not only broad
                  generalizations. We also provide daily horoscopes that keep
                  you in tune with the planetary energy for those who want
                  insights more frequently. Every day has a unique cosmic
                  vibration, and being conscious of these minute changes may
                  help you make better choices. Our horoscopes serve as your
                  astrological guide, advising you on when to start a project,
                  communicate your feelings, or maintain your sense of reality.
                </p>
                <h3>
                  All Zodiac Signs Can Get Customized Online Astrology
                  Predictions
                </h3>
                <p>
                  Getting an Online Astrology Prediction from the comfort of
                  your home is made easy by{" "}
                  <a href="/" className="fw-bold">
                    Blessings Astrology
                  </a>
                  . Astrology is more accessible than ever in the digital era.
                  All twelve zodiac signs, from Aries to Pisces, are accurately
                  and clearly covered in our horoscope department. Whether
                  you're interested in your romantic life, professional
                  prospects, or just the mood of the day, our horoscopes offer
                  insightful advice that's simple to comprehend and implement.
                  Our forecasts are made by qualified astrologers with years of
                  expertise in Vedic astrology,{" "}
                  <a href="/service/numerology" className="fw-bold">
                    numerology
                  </a>
                  , and spiritual sciences, in contrast to generic horoscopes
                  you could get elsewhere. Their knowledge enables them to
                  decipher planetary motions in connection to the distinct
                  energies of every sign, guaranteeing that your forecasts are
                  precise, perceptive, and pertinent.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {showForm && (
        <Appointmentform
          serviceName={serviceTitle}
          showForm={showForm}
          closeModal={closeModal}
        />
      )}
    </>
  );
}
